<template>
  <default-modal
    ref="box"
    :title="title"
    :modalWidth="680"
    :confirmBtn="false"
    :cancleTxt="`关闭`"
  >
    <div
      class="commonLine"
      style="margin-top:30px;padding-left:40px;padding-top:20px;padding-bottom:30px;"
    >
      <div class="left">
        <span>远程协助码：</span>
      </div>
      <div class="left assistanceCode">
        <input
          type="text"
          v-model="remoteKey"
          style="width:300px;border: 1px solid rgb(230, 230, 230);height:30px;"
          placeholder="点击生成远程授权码"
        />
        <a
          href="#"
          v-show="!remoteKey"
          @click.prevent="createAssistCode"
          class="blue-btn"
        >生成授权码</a>
        <a
          href="#"
          style="margin-left:10px;"
          v-show="remoteKey"
          @click.prevent="killAssistRemoteKey"
          class="blue-btn"
        >销毁授权码</a>
      </div>
      <div class="left copy">
        <a
          href="#"
          @click="doCopy"
          id="button"
        >
          <img
            src="@/assets/img/icon/u625.png"
            alt=""
          /> 复制授权码
        </a>
      </div>
    </div>
  </default-modal>
</template>

<script>
import DefaultModal from "_c/modals/defaultModal";
import {
  getAssistRemoteKey,
  createAssistRemoteKey,
  killAssistRemoteKey
} from "@/requests/bar";

export default {
  name: "barModals",
  components: {
    DefaultModal
  },
  data() {
    return {
      title: "设置远程授权码",
      barId: "",
      remoteKey: ""
    };
  },
  mounted() {
    window.$modal.assistCodeModal = {};
    window.$modal.assistCodeModal.show = ({ barId }) => {
      this.barId = barId;
      this.init();
      this.show();
    };
    //监听键盘按键事件
    let self = this;
    this.$nextTick(function () {
      document.addEventListener('keyup', function (e) {
        //此处填写你的业务逻辑即可
        if (e.keyCode == 27) {
          self.$refs.box.hide();
        }
      })
    })
  },
  methods: {
    async init() {
      let res = await getAssistRemoteKey({
        barId: this.barId
      });
      if (res.code == 200) {
        this.remoteKey = res.data;
      }
    },
    show() {
      this.$refs.box.show();
    },
    async createAssistCode() {
      let res = await createAssistRemoteKey({
        barId: this.barId
      });
      if (res.code == 200) {
        this.remoteKey = res.data;
      }
    },
    async killAssistRemoteKey() {
      let res = await killAssistRemoteKey({
        barId: this.barId
      });
      if (res.code == 200) {
        this.remoteKey = "";
      } else {
        this.$refs.box.setWrong(res.msg);
      }
    },
    doCopy() {
      /* eslint-disable */
      this.$copyText(this.remoteKey).then(
        function (e) {
          return window.$msg({
            showClose: true,
            type: "success",
            message: "复制成功"
          });
          //   alert('复制成功')
        },
        function (e) {
          //   alert('复制失败')
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "_style/msgbox/_msgBox.scss";
@import "_style/msgbox/_comMsg.scss";
@import "_style/_color.scss";
.setRemoteAssistance {
  height: 200px;
  .content {
    padding-left: 50px;
    .commonLine {
      .assistanceCode {
        input {
          width: 200px;
          height: 30px;
          // border: 1px solid rgba(231, 230, 230, 1);
          padding-left: 10px;
        }
        a {
          width: 100px;
          height: 30px;
          padding: 0;
          text-align: center;
          line-height: 30px;
          color: #fff;
        }
      }
      .copy {
        height: 30px;
        line-height: 30px;
        margin-left: 10px;
        a {
          color: $blue-1;
        }
      }
    }
  }
}
.copy {
  height: 30px;
  line-height: 30px;
  margin-left: 10px;
  a {
    color: $blue-1;
  }
}
</style>
